import { Box, Grid, TextField, InputLabel, Button, ToggleButtonGroup, ToggleButton, FormControl, Autocomplete, Chip } from "@mui/material"
import { useClassification } from "../../../../shared/context/classificactionContext"
import { Controller, useForm } from "react-hook-form"
import { useEffect, useState } from "react"
import { useLocations } from "../../../../shared/context/locationsContext"
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useEquipment } from "../../../../shared/context/equipmentContext"  
export default function FilterEquipmentComponent({ type_asset }) {
    const [valueClassification1, setValueClassification1] = useState('');
    const [valueClassification2, setValueClassification2] = useState('');

    // Cargar los valores guardados de localStorage si existen
    const getSavedFormValues = () => {
        const savedForm = localStorage.getItem(`equipment_filter_${type_asset}`);
        if (savedForm) {
            try {
                return JSON.parse(savedForm);
            } catch (e) {
                console.error("Error parsing saved form data", e);
            }
        }
        return {
            code: '',
            name: '',
            enabled: "true",
            out_of_service: "false",
            classification1: [],
            classification2: [],
            description: '',
            parent: ''
        };
    };

    const { control, setValue, handleSubmit, watch } = useForm({
        defaultValues: getSavedFormValues()
    });

    // Guardar los valores del formulario en localStorage cada vez que cambien
    const formValues = watch();
    useEffect(() => {
        localStorage.setItem(`equipment_filter_${type_asset}`, JSON.stringify(formValues));
    }, [formValues, type_asset]);

    const onSubmit = (data) => {
        console.log(data)
        getEquipments(data)
    }
    
    const { classifications, getClassification } = useClassification()
    const { locationsOptions, getLocationsOptions, getLocations } = useLocations()
    const { equipments, getEquipments, pagination } = useEquipment()
    
    useEffect(() => {
        getClassification({ type_asset })
        getLocationsOptions()
    }, [type_asset])
     
    const handleClearForm = () => {
        // Limpiar el formulario y localStorage
        const defaultValues = {
            code: '',
            name: '',
            enabled: true,
            out_of_service: false,
            classification1: [],
            classification2: [],
            description: '',
            location: ''
        };
        
        Object.keys(defaultValues).forEach(key => {
            setValue(key, defaultValues[key]);
        });
        
        localStorage.removeItem(`equipment_filter_${type_asset}`);
        getEquipments()
    };

    return (
        <Box sx={{padding: 2}}>
            <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} columns={12}>
                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Código</InputLabel>
                    <Controller
                        control={control}
                        name="code"
                        render={({ field }) => (
                            <TextField
                                name="code"
                                fullWidth
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>

                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Nombre</InputLabel>
                    <Controller
                        control={control}
                        name="name"
                        render={({ field }) => (
                            <TextField
                                name="name"
                                fullWidth
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                            />
                        )}
                    />
                </Grid>


                <Grid item size={{ xs: 12}}>
                    <InputLabel id="classification1-label" sx={{fontSize: 14, fontWeight: 600}}>Clasificación 1</InputLabel>
                    <Controller
                        control={control}
                        name="classification1"
                        render={({ field }) => (
                            <FormControl fullWidth>
                                <Autocomplete
                                    multiple
                                    disablePortal={false}
                                    onOpen={() => {
                                        getClassification({ type_asset, number: 1 });
                                    }}
                                    disableCloseOnSelect
                                    options={classifications || []}
                                    getOptionLabel={(option) => option.value || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    value={classifications ? classifications.filter(c => field.value.includes(c.id)) : []}
                                    onChange={(_, newValue) => {
                                        setValue(field.name, newValue.map(item => item.id));
                                    }}
                                    freeSolo
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>{option.value}</li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder={classifications?.length ? "Seleccionar clasificaciones" : "Cargando..."}
                                            variant="outlined"
                                            fullWidth
                                            onChange={(e) => {
                                                getClassification({ type_asset, number: 1, search: e.target.value });
                                            }}
                                        />
                                    )}
                                    slotProps={{
                                        popper: {
                                            style: { zIndex: 1301 }
                                        }
                                    }}
                                    noOptionsText="No hay clasificaciones disponibles"
                                    loadingText="Cargando clasificaciones..."
                                />
                            </FormControl>
                        )}
                    />  
                </Grid>

                <Grid item size={{ xs: 12}}>
                    <InputLabel id="classification2-label" sx={{fontSize: 14, fontWeight: 600}}>Clasificación 2</InputLabel>
                    <Controller
                        control={control}
                        name="classification2"
                        render={({ field }) => (
                            <FormControl fullWidth>
                                <Autocomplete
                                    multiple
                                    disablePortal={false}
                                    onOpen={() => {
                                        getClassification({ type_asset, number: 2 });
                                    }}
                                    disableCloseOnSelect
                                    options={classifications || []}
                                    getOptionLabel={(option) => option.value || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    value={classifications ? classifications.filter(c => field.value.includes(c.id)) : []}
                                    onChange={(_, newValue) => {
                                        setValue(field.name, newValue.map(item => item.id));
                                    }}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>{option.value}</li>
                                    )}
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder={classifications?.length ? "Seleccionar clasificaciones" : "Cargando..."}
                                            variant="outlined"
                                            fullWidth
                                            onChange={(e) => {
                                                getClassification({ type_asset, number: 2, search: e.target.value });
                                            }}
                                        />
                                    )}
                                    slotProps={{
                                        popper: {
                                            style: { zIndex: 1301 }
                                        }
                                    }}
                                    noOptionsText="No hay clasificaciones disponibles"
                                    loadingText="Cargando clasificaciones..."
                                />
                            </FormControl>
                        )}
                    />
                </Grid>


                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Ubicación</InputLabel>
                    <Controller
                        control={control}
                        name="location"
                        render={({ field }) => (
                            <FormControl fullWidth>
                                <Autocomplete
                                    disablePortal={false}
                                    onOpen={() => {
                                        getLocationsOptions();
                                    }}
                                    onInputChange={(event, newValue) => {
                                        getLocationsOptions({ name: newValue });
                                    }}
                                    options={locationsOptions || []}
                                    getOptionLabel={(option) => option?.name || ""}
                                    isOptionEqualToValue={(option, value) => option.id === value?.id}
                                    value={locationsOptions ? locationsOptions.find(l => l.id === field.value) || null : null}
                                    onChange={(_, newValue) => {
                                        setValue(field.name, newValue ? newValue.id : null);
                                    }}
                                    renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <LocationOnIcon sx={{ color: 'primary.main', mr: 1 }} fontSize="small" />
                                                {option.name}
                                            </Box>
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Seleccionar ubicación"
                                            variant="outlined"
                                        />
                                    )}
                                    slotProps={{
                                        popper: {
                                            style: { zIndex: 1301 }
                                        }
                                    }}
                                    noOptionsText="No hay ubicaciones disponibles"
                                    loadingText="Cargando ubicaciones..."   
                                />
                            </FormControl>
                        )}
                    />
                </Grid>


                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Habilitado</InputLabel>
                    <Controller
                        control={control}
                        name="enabled"
                        render={({ field }) => (
                            <ToggleButtonGroup
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                                exclusive
                                fullWidth
                                color="primary"
                                sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600 }}
                            >
                                <ToggleButton value={"true"}>Si</ToggleButton>
                                <ToggleButton value={"false"}>No</ToggleButton>
                            </ToggleButtonGroup>
                        )}
                    />
                </Grid>



                <Grid item size={{ xs: 12}}>
                    <InputLabel sx={{fontSize: 14, fontWeight: 600}}>Fuera de servicio</InputLabel>
                    <Controller
                        control={control}
                        name="out_of_service"
                        render={({ field }) => (
                            <ToggleButtonGroup
                                value={field.value}
                                onChange={(e) => setValue(field.name, e.target.value)}
                                exclusive
                                fullWidth
                                color="primary"
                                sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600 }}
                            >
                                <ToggleButton value={"true"}>Si</ToggleButton>
                                <ToggleButton value={"false"}>No</ToggleButton>
                            </ToggleButtonGroup>
                        )}
                    />
                </Grid>



                <Grid item size={{ xs: 12}}>
                    <Button variant="contained" color="primary" fullWidth size="large" type="submit"
                    sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600 }}>Buscar</Button>
                    <Button 
                        variant="contained" 
                        color="disabled" 
                        fullWidth 
                        size="large"
                        onClick={handleClearForm}
                        sx={{ borderRadius: 2, height: 40, fontSize: 14, fontWeight: 600, mt: "5px" }}
                    >
                        Limpiar
                    </Button>
                </Grid>
                
                
                
            </Grid>
            </form>
        </Box>
    )
}